/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';

import {AbstractField} from '../abstract-field';

/**
 * Date picker form field.
 */
@Component({
  selector: 'gp-form-field-month',
  template: `
    <datepicker-input
      minMode="month"
      datepickerMode="month"
      [showWeeks]="false"
      [(ngModel)]="value.value"
      [attr.test-id]="descriptor.zoneID"
      [formControl]="control"
      [groupZoneDescriptor]="groupZoneDescriptor"
      [readOnly]="readOnly"
      [correctToExtremeValues]="false"
      [isAppendToBody]="isAppendToBody"
      ngDefaultControl>
    </datepicker-input>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class MonthFieldComponent extends AbstractField {
  @Input() public isAppendToBody = false;
}
